import React from 'react'

export default function BasketsDuplicateHeader() {
    return (
        <thead className='thead-light BasketsDuplicateHeader'>
            <tr>
                <th>Số giỏ</th>
                <th>Loại giỏ</th>
                <th>Địa chỉ</th>
                <th>Số lượng giỏ</th>
                <th>Docs (ids)</th>
                <th style={{ width: 180 }}>Actions</th>
            </tr>
        </thead>
    )
}
